import React from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import { useState } from 'react';

const WelcomePage = () => {
  const [name, setName] = useState('');
  const [submitted, setSubmitted] = useState(false);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '80vh' }}>
      <Card title="Welcome to React PH Registration" style={{ width: '400px' }}>
        <p className="m-0" style={{ marginBottom: '1.5rem' }}>
          This is a sample homepage using PrimeReact components.
        </p>
        <span className="p-float-label" style={{ display: 'block', marginBottom: '1rem' }}>
          <InputText id="name" value={name} onChange={e => setName(e.target.value)} />
          <label htmlFor="name">Enter your name</label>
        </span>
        <Button label="Submit" icon="pi pi-check" onClick={() => setSubmitted(true)} className="p-button-success" style={{ width: '100%' }} />
        {submitted && (
          <Message severity="info" text={`Hello, ${name || 'Guest'}!`} style={{ marginTop: '1rem' }} />
        )}
      </Card>
    </div>
  );
};

export default WelcomePage;
